export default {
    methods: {
        loadingButton(e, loadingBool) {
            const loadingClass = 'save-button-spinner';

            if (loadingBool) {
                this.loadingButtonAddSpinner(e.target, loadingClass);
            }
            else {
                this.loadingButtonRemoveSpinner(e.target, loadingClass);
            }
        },
        loadingButtonAddSpinner(element, loadingClass) {
            element.setAttribute('disabled', 'disabled');
            element.classList.add(loadingClass);
        },
        loadingButtonRemoveSpinner(element, loadingClass) {
            element.removeAttribute('disabled');
            element.classList.remove(loadingClass);
        }
    }
};
